"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var HexToRgb = function HexToRgb(hex) {
  var hexCode = hex.replace('#', '');
  var red = parseInt(hexCode.substring(0, 2), 16);
  var green = parseInt(hexCode.substring(2, 4), 16);
  var blue = parseInt(hexCode.substring(4, 6), 16);
  var rgbValue = "".concat(red, ", ").concat(green, ", ").concat(blue);
  return rgbValue;
};

var _default = HexToRgb;
exports.default = _default;
module.exports = exports.default;